import { render, staticRenderFns } from "./PurchasedAService.vue?vue&type=template&id=945c8f24&scoped=true&"
import script from "./PurchasedAService.vue?vue&type=script&lang=js&"
export * from "./PurchasedAService.vue?vue&type=script&lang=js&"
import style0 from "./PurchasedAService.vue?vue&type=style&index=0&id=945c8f24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945c8f24",
  null
  
)

export default component.exports